const MAIN_FRAMES = {
  HOST_VIEW: 'Host View',
  HOST_DETAIL: 'Host Detail',
  HOST_PROCESS_DETAIL: 'Process Detail - Host',
  HOST_NETWORK_DETAIL: 'Network Detail - Host',
  HOST_DISK_DETAIL: 'Disk Detail - Host',
  HOST_GPU_DETAIL: 'GPU Detail - Host',
  HOST_ALERT_DETAIL: 'Alert Detail - Host',

  GPU_OVERVIEW_VIEW: 'GPU Overview View',
  GPU_MONITORING_VIEW: 'GPU Monitoring View',
  GPU_RESOURCE_VIEW: 'GPU Resource View',
  GPU_WORKLOAD_VIEW: 'GPU Workload View',
  GPU_DETAIL: 'GPU Detail',
  GPU_ALERT_DETAIL: 'Alert Detail - GPU',

  CONTAINER_VIEW: 'Container View',
  CONTAINER_DETAIL: 'Container Detail',
  CONTAINER_ALERT_DETAIL: 'Alert Detail - Container',

  NETWORK_DEVICE_VIEW: 'Network Device View',
  NETWORK_DEVICE_DETAIL: 'Network Device Detail',
  NETWORK_DEVICE_ALERT_DETAIL: 'Alert Detail - Network Device',

  NPM: 'Network Performance Monitoring View',
  NETWORK_OBJECT_DETAIL: 'Network Object Detail',
  NETWORK_OBJECT_ALERT_DETAIL: 'Alert Detail - Network Object',
} as const;

export const INFRA_FRAME_NAMES = {
  // Host
  HOST_VIEW: {
    FILTERS: `${MAIN_FRAMES.HOST_VIEW}/Filters`,
    HOST_LIST: `${MAIN_FRAMES.HOST_VIEW}/Host List`,
    ALERT_COUNT: `${MAIN_FRAMES.HOST_VIEW}/Alert Count`,
  },
  HOST_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.HOST_DETAIL}/Information`,
    METRIC: `${MAIN_FRAMES.HOST_DETAIL}/Metric`,
    PROCESS: `${MAIN_FRAMES.HOST_DETAIL}/Process`,
    NETWORK: `${MAIN_FRAMES.HOST_DETAIL}/Network`,
    DISK: `${MAIN_FRAMES.HOST_DETAIL}/Disk`,
    GPU: `${MAIN_FRAMES.HOST_DETAIL}/GPU`,
    CONTAINER: `${MAIN_FRAMES.HOST_DETAIL}/Container`,
    INSTALLED_PACKAGE: `${MAIN_FRAMES.HOST_DETAIL}/Installed Package`,
    RELATIONAL_INFORMATION: `${MAIN_FRAMES.HOST_DETAIL}/Relational Information`,
    AGENT: `${MAIN_FRAMES.HOST_DETAIL}/Agent`,
    ALERT: `${MAIN_FRAMES.HOST_DETAIL}/Alert`,
  },
  K8S_NODE_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.HOST_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.HOST_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.HOST_DETAIL}/Clear System Alert`,
  },
  HOST_PROCESS_DETAIL: {
    INFO: `${MAIN_FRAMES.HOST_PROCESS_DETAIL}/Info`,
    GPU_RESOURCE_MAP: `${MAIN_FRAMES.HOST_PROCESS_DETAIL}/GPU Resource Map`,
    PROCESS_STAT: `${MAIN_FRAMES.HOST_PROCESS_DETAIL}/Process Stat`,
  },
  HOST_NETWORK_DETAIL: {
    NETWORK_STAT: `${MAIN_FRAMES.HOST_NETWORK_DETAIL}/Network Stat`,
  },
  HOST_DISK_DETAIL: {
    DISK_STAT: `${MAIN_FRAMES.HOST_DISK_DETAIL}/Disk Stat`,
  },
  HOST_GPU_DETAIL: {
    INFO: `${MAIN_FRAMES.HOST_GPU_DETAIL}/Info`,
    GPU_STAT: `${MAIN_FRAMES.HOST_GPU_DETAIL}/GPU Stat`,
  },
  HOST_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.HOST_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.HOST_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.HOST_ALERT_DETAIL}/Clear System Alert`,
  },

  // GPU Overview View (gpuView/gpuOverviewView)
  GPU_OVERVIEW_VIEW: {
    ALERT_COUNT: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Alert Count`,
    STATUS_RESOURCE: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Status Resource`,
    STATUS_HEALTH: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Status Health`,
    GAUGE_GPU_UTIL: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Gauge GPU Util`,
    GAUGE_MEMORY: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Gauge Memory`,
    GAUGE_TEMPERATURE: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Gauge Temperature`,
    TOP_GPU_UTIL: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Top GPU Util`,
    TOP_MEMORY: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Top Memory`,
    TOP_TEMPERATURE_LOAD: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Top Temperature Load`,
    TOP_POWER_LOAD: `${MAIN_FRAMES.GPU_OVERVIEW_VIEW}/Top Power Load`,
  },

  // GPU Monitoring View
  GPU_MONITORING_VIEW: {
    ALERT_COUNT: `${MAIN_FRAMES.GPU_MONITORING_VIEW}/Alert Count`,
    FILTERS: `${MAIN_FRAMES.GPU_MONITORING_VIEW}/Filters`,
    GPU_LIST: `${MAIN_FRAMES.GPU_MONITORING_VIEW}/GPU List`,
  },

  // GPU Resource View
  GPU_RESOURCE_VIEW: {
    ALERT_COUNT: `${MAIN_FRAMES.GPU_RESOURCE_VIEW}/Alert Count`,
    FILTERS: `${MAIN_FRAMES.GPU_RESOURCE_VIEW}/Filters`,
    TARGETS: `${MAIN_FRAMES.GPU_RESOURCE_VIEW}/Filter Targets`,
    DEVICE_LIST: `${MAIN_FRAMES.GPU_RESOURCE_VIEW}/Device List`,
    METRICS: `${MAIN_FRAMES.GPU_RESOURCE_VIEW}/Metrics`,
  },

  // GPU Workload Overview
  GPU_WORKLOAD_VIEW: {
    FILTERS: `${MAIN_FRAMES.GPU_WORKLOAD_VIEW}/Filters`,
    SUMMARY: `${MAIN_FRAMES.GPU_WORKLOAD_VIEW}/Computing Overview`,
    BREAKDOWN: `${MAIN_FRAMES.GPU_WORKLOAD_VIEW}/Group Breakdown`,
    TRENDS: `${MAIN_FRAMES.GPU_WORKLOAD_VIEW}/GPU Performance Trends`,
    POD_LIST: `${MAIN_FRAMES.GPU_WORKLOAD_VIEW}/Pod List`,
  },

  // GPU Detail
  GPU_DETAIL: {
    INFO: `${MAIN_FRAMES.GPU_DETAIL}/Info`,
    METRIC: `${MAIN_FRAMES.GPU_DETAIL}/Metric`,
    PROCESS: `${MAIN_FRAMES.GPU_DETAIL}/Process`,
    POD: `${MAIN_FRAMES.GPU_DETAIL}/Pod`,
    MIG: `${MAIN_FRAMES.GPU_DETAIL}/MIG`,
    ALERT: `${MAIN_FRAMES.GPU_DETAIL}/Alert`,
  },

  GPU_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.GPU_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.GPU_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.GPU_ALERT_DETAIL}/Clear System Alert`,
  },

  // Container
  CONTAINER_VIEW: {
    FILTERS: `${MAIN_FRAMES.CONTAINER_VIEW}/Filters`,
    CONTAINER_LIST: `${MAIN_FRAMES.CONTAINER_VIEW}/Container List`,
    ALERT_COUNT: `${MAIN_FRAMES.CONTAINER_VIEW}/Alert Count`,
  },
  CONTAINER_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.CONTAINER_DETAIL}/Information`,
    METRIC: `${MAIN_FRAMES.CONTAINER_DETAIL}/Metric`,
    RELATIONAL_INFORMATION: `${MAIN_FRAMES.CONTAINER_DETAIL}/Relational Information`,
    LOG: `${MAIN_FRAMES.CONTAINER_DETAIL}/Log`,
    APPLICATION_GET: `${MAIN_FRAMES.CONTAINER_DETAIL}/[GET] Application`,
    ACTIVES: `${MAIN_FRAMES.CONTAINER_DETAIL}/Actives`,
    ACTIVES_DETAIL: `${MAIN_FRAMES.CONTAINER_DETAIL}/Actives Detail`,
    ACTIVES_DETAIL_KILL_THREAD: `${MAIN_FRAMES.CONTAINER_DETAIL}/Actives Detail - Kill Thread`,
    DATA_SOURCE: `${MAIN_FRAMES.CONTAINER_DETAIL}/Data Source`,
    TRANSACTIONS: `${MAIN_FRAMES.CONTAINER_DETAIL}/Transactions`,
    ALERT: `${MAIN_FRAMES.CONTAINER_DETAIL}/Alert`,
  },
  CONTAINER_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.CONTAINER_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.CONTAINER_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.CONTAINER_ALERT_DETAIL}/Clear System Alert`,
  },

  // Network Device
  NETWORK_DEVICE_VIEW: {
    DEVICE_LIST: `${MAIN_FRAMES.NETWORK_DEVICE_VIEW}/Device List`,
    FILTERS: `${MAIN_FRAMES.NETWORK_DEVICE_VIEW}/Filters`,
    TOP_5_LIST: `${MAIN_FRAMES.NETWORK_DEVICE_VIEW}/Top 5 List`,
    ALERT_COUNT: `${MAIN_FRAMES.NETWORK_DEVICE_VIEW}/Alert Count`,
  },
  NETWORK_DEVICE_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/Information`,
    INTERFACE: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/Interface`,
    METRIC: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/Metric`,
    SYSLOG: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/SysLog`,
    SNMP_TRAP: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/SNMP Trap`,
    ALERT: `${MAIN_FRAMES.NETWORK_DEVICE_DETAIL}/Alert`,
  },
  NETWORK_DEVICE_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.NETWORK_DEVICE_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.NETWORK_DEVICE_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.NETWORK_DEVICE_ALERT_DETAIL}/Clear System Alert`,
  },

  // NPM
  NPM: {
    FILTERS: `${MAIN_FRAMES.NPM}/Filters`,
    OVERVIEW: `${MAIN_FRAMES.NPM}/Overview`,
    PERFORMANCE_TREND_MONITORING: `${MAIN_FRAMES.NPM}/Performance Trend Monitoring`,
    NETWORK_TOPOLOGY: `${MAIN_FRAMES.NPM}/Network Topology`,
    ALERT_COUNT: `${MAIN_FRAMES.NETWORK_OBJECT_ALERT_DETAIL}/Alert Count`,
  },
  NETWORK_OBJECT_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.NETWORK_OBJECT_DETAIL}/Information`,
    METRIC: `${MAIN_FRAMES.NETWORK_OBJECT_DETAIL}/Metric`,
    SESSION: `${MAIN_FRAMES.NETWORK_OBJECT_DETAIL}/Session`,
    ALERT: `${MAIN_FRAMES.NETWORK_OBJECT_DETAIL}/Alert`,
  },
  NETWORK_OBJECT_ALERT_DETAIL: {
    ALERT_GROUP_AND_RULES: `${MAIN_FRAMES.NETWORK_OBJECT_ALERT_DETAIL}/Alert Group and Rules`,
    CLEAR_ALERT_RULE: `${MAIN_FRAMES.NETWORK_OBJECT_ALERT_DETAIL}/Clear User Alert`,
    CLEAR_SYSTEM_RULE: `${MAIN_FRAMES.NETWORK_OBJECT_ALERT_DETAIL}/Clear System Alert`,
  },
} as const;
